import { Layout as DefaultLayout, AppBar, TitlePortal } from 'react-admin'
import Menu from './Menu'
import { useLocation } from 'react-router-dom'
import { AppBarProps } from '@mui/material'
import usePageTracking from '@/lib/segment/hooks/usePageTracking'
import usePartnerName from './hooks/usePartnerName'
import Footer from '@/components/Footer'
import { MultiRoleInfo } from './PartnerInfo'

const PAGE_TITLES: Record<string, string> = {
  '/calendar': 'Calendar',
  '/roles': 'Role Select',
  '/resources': 'Resources',
  '/stack-media': 'Stack Media',
  '/account/general-info': 'Account / General Info',
  '/account/payment-info': 'Account / Payment Info',
  '/earnings/deductions': 'Earnings / Deductions',
  '/earnings/payment-status': 'Earnings / Payment Status',
  '/orders': 'Orders'
}

const NO_LAYOUT_PAGES = ['/affiliates/create']

const getPageTitle = (pathname: string, partnerName: string) => {
  const entry = Object.entries(PAGE_TITLES).find(([key]) =>
    pathname.startsWith(key)
  )
  return entry
    ? partnerName
      ? `${partnerName} / ${entry[1]}`
      : entry[1]
    : null
}

const CustomAppBar = (props: AppBarProps) => {
  const location = useLocation()
  const partnerName = usePartnerName()

  return (
    <AppBar {...props} color="primary">
      <TitlePortal
        variant="h2"
        color="inherit"
        sx={{ fontSize: '1.25rem', fontWeight: 'bold', flex: 1 }}
      >
        <>{getPageTitle(location.pathname, partnerName)}</>
      </TitlePortal>
      <MultiRoleInfo />
    </AppBar>
  )
}

const Layout = ({ children }: { children: React.ReactNode }) => {
  usePageTracking()
  const location = useLocation()
  const hideLayout = NO_LAYOUT_PAGES.some((path) =>
    location.pathname.startsWith(path)
  )

  if (hideLayout) return <>{children}</>

  return (
    <>
      <DefaultLayout
        menu={Menu}
        appBar={CustomAppBar}
        sx={{
          '& .RaSidebar-fixed': {
            height: 'calc(100vh - 15em)'
          }
        }}
      >
        {children}

        <Footer
          sx={{
            left: 0,
            bottom: 0,
            position: 'fixed',
            width: '100%'
          }}
        />
      </DefaultLayout>
    </>
  )
}

export default Layout
